import * as React from 'react';
import { IconActionChevronDownSmall16, IconActionChevronUpSmall16 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './ExpandButton.css';

export interface IExpandButtonProps {
  expanded: boolean;
  expandText?: string;
  onClick(): void;
}

export const ExpandButton: React.FC<IExpandButtonProps> = ({ expanded, expandText, onClick }) => {
  return (
    <button type="button" className={styles['button']} onClick={onClick}>
      {expanded ? 'Свернуть' : expandText || 'Узнать больше'}
      <span className={styles['icon']}>
        {expanded ? (
          <IconActionChevronUpSmall16 color="icon-main-default" />
        ) : (
          <IconActionChevronDownSmall16 color="icon-main-default" />
        )}
      </span>
    </button>
  );
};
